import { Article } from "../../../models/Article";
import { Link, useSearchParams } from "react-router-dom";
import Grid2 from "@mui/material/Unstable_Grid2";
import { ResultPagination } from "../../../components/pagination/result-pagination";
import { Typography } from "@mui/material";
import { ResultBox } from "../../result/result-box";
import { MobileAggregations } from "../../../components/aggregations/devices/mobile-aggregations";
import { ShareSearchResult } from "../../share/share-search-result";
import { useResultMessage } from "../../../hooks/use-result-message";
import {useMemo} from "react";

interface ISearchResultsProps {
  results?: {
    total: {
      value: number;
    };
    docs: Article[];
  };
  aggregations?: any;
  title?: string;
  description?: string;
  lockedAggregations?: {[key:string]: string[]};
}
export const SearchResults = ({
  results,
  aggregations,
  title,
  description,
  lockedAggregations = {},
}: ISearchResultsProps) => {
  const [searchParams] = useSearchParams();

  const resultMessage = useResultMessage(results);

  const searchResultMessage = useMemo(() => {
    if(title) {
      return title;
    }
    //keep this for backwards compatability
    const sortOrder = searchParams.get("sortOrder");
    if (sortOrder === "-PUBDATE") {
      return "Latest Publications";
    } else return "Search Result";
  }, [searchParams, title]);

  return (
    <Grid2
      container
      justifyContent={{ xs: "center", md: "left" }}
      direction="column"
      maxWidth={"900px"}
      ml={{ md: "2rem" }}
      mb={"2rem"}
    >
      <Grid2 container sx={{ display: { xs: "none", md: "flex" } }} mb={4}>
        <Grid2 xs={12}>
          <h2> {searchResultMessage} </h2>
          {description && <p>{description}</p>}
        </Grid2>
        <Grid2 style={{marginTop:"1rem"}} xs={12} display={"flex"} justifyContent={"space-between"}>
          {resultMessage}
          {results && results?.total?.value !== 0 && <ShareSearchResult />}
        </Grid2>
        <Grid2 xs={12}>
          {results?.total.value === 0 ? (
            <span>
              <h3>
                {" "}
                Do you know any articles related to the query "
                {searchParams.get("query")?.trim()}"?
              </h3>
              <p>
                Try suggesting them to ELTRP! <br />
                Reach out to us with your suggestion!
              </p>
              <p>
                Read more under our <Link to={"/contact"}> contact page</Link>.
              </p>
            </span>
          ) : (
            <></>
          )}
        </Grid2>
      </Grid2>
      <Grid2
        xs={12}
        container
        sx={{ display: { xs: "flex", md: "none" } }}
        mb={4}
      >
        <Grid2 xs={8}>
          <h2 style={{ marginBottom: "0" }}> {searchResultMessage} </h2>
          {description && <p>{description}</p>}
          <Typography variant={"subtitle2"}> {resultMessage}</Typography>
        </Grid2>

        {results?.total.value !== 0 && (
          <Grid2
            display={"flex"}
            xs={4}
            justifyContent={"right"}
            alignItems={"center"}
          >
            <MobileAggregations aggregations={aggregations} lockedAggregations={lockedAggregations}/>
          </Grid2>
        )}

        {results?.total.value === 0 ? (
          <span>
            <h3>
              {" "}
              Do you know any articles related to the query "
              {searchParams.get("query")?.trim()}"?
            </h3>
            <p>
              Try suggesting them to ELTRP! <br />
              Reach out to us with your suggestion!
            </p>
            <p>
              Read more under our <Link to={"/contact"}> contact page</Link>.
            </p>
          </span>
        ) : (
          <></>
        )}
      </Grid2>
      <div
        className="searchResult"
        style={{ display: results?.total.value ? "inline" : "none" }}
      >
        <ResultBox results={results?.docs} sharable={true}/>
        <ResultPagination value={results?.total.value} />
      </div>
    </Grid2>
  );
};
